// Customization: keep the floating mobile filter/sort button hidden
// until the in-flow trigger has scrolled out of view.
function initMobileFacetFloatingFilterVisibility() {
  const floatingFilters = document.querySelectorAll('facet-floating-filter[trigger-selector]');

  floatingFilters.forEach((floatingFilter) => {
    const section = floatingFilter.closest('.shopify-section');
    const triggerSelector = floatingFilter.getAttribute('trigger-selector') || '[data-facet-top-trigger]';

    floatingFilter._mobileFacetCleanup?.();

    const syncVisibility = () => {
      // Re-query on every sync because facet updates can replace DOM nodes.
      const topTrigger = section?.querySelector(triggerSelector) || document.querySelector(triggerSelector);
      const footer = document.querySelector('.shopify-section--footer');
      const topTriggerPassed = topTrigger ? topTrigger.getBoundingClientRect().bottom < 0 : false;
      const footerVisible = footer
        ? footer.getBoundingClientRect().top < window.innerHeight && footer.getBoundingClientRect().bottom > 0
        : false;
      const nearTopOfPage = window.scrollY < 24;
      const shouldShow = !nearTopOfPage && topTriggerPassed && !footerVisible;

      floatingFilter.classList.toggle('facet-floating-filter--custom-visible', shouldShow);
      floatingFilter.classList.toggle('facet-floating-filter--custom-hidden', !shouldShow);
    };

    const onScrollOrResize = () => {
      window.requestAnimationFrame(syncVisibility);
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    syncVisibility();

    floatingFilter._mobileFacetCleanup = () => {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    };
  });
}

function resyncMobileFacetFloatingFilterVisibility() {
  initMobileFacetFloatingFilterVisibility();

  // Facet updates can re-render in multiple micro-steps; re-sync after layout settles.
  [120, 300, 600].forEach((delay) => {
    window.setTimeout(initMobileFacetFloatingFilterVisibility, delay);
  });

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(initMobileFacetFloatingFilterVisibility);
  });
}

document.addEventListener('DOMContentLoaded', initMobileFacetFloatingFilterVisibility);
document.addEventListener('shopify:section:load', initMobileFacetFloatingFilterVisibility);
document.addEventListener('facet:update', () => {
  resyncMobileFacetFloatingFilterVisibility();
});

// Customization: reopen the cart drawer after Globe pickup point modal closes.
function initGlobeCartModalDrawerRecovery() {
  const observeModal = (modal) => {
    if (modal.dataset.cartDrawerRecoveryObserved === 'true') {
      return;
    }

    modal.dataset.cartDrawerRecoveryObserved = 'true';

    let wasOpen = modal.hasAttribute('open');

    new MutationObserver(() => {
      const isOpen = modal.hasAttribute('open');

      if (wasOpen && !isOpen) {
        const cartDrawer = document.querySelector('#cart-drawer');

        if (cartDrawer && !cartDrawer.hasAttribute('open')) {
          window.setTimeout(() => {
            cartDrawer.show?.();
          }, 250);
        }
      }

      wasOpen = isOpen;
    }).observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });
  };

  const syncModalObserver = () => {
    const modal = document.querySelector('#globe-cart-container');

    if (modal) {
      observeModal(modal);
    }
  };

  syncModalObserver();

  if (document.body.dataset.globeCartModalRecoveryObserved === 'true') {
    return;
  }

  document.body.dataset.globeCartModalRecoveryObserved = 'true';

  new MutationObserver(syncModalObserver).observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', initGlobeCartModalDrawerRecovery);
document.addEventListener('shopify:section:load', initGlobeCartModalDrawerRecovery);
